import { useState, useLayoutEffect } from 'react';
import type { RefObject } from 'react';
import { debounce } from 'lodash-es';
import type { CanvasRef } from '@hotjar/heatmaps';

const calculateScale = (heatmapHeight: number, canvasRef: RefObject<CanvasRef>): number =>
  (canvasRef.current?.height() ?? 0) / heatmapHeight;

export function useHeatmapScale(heatmapHeight: number, canvasRef: RefObject<CanvasRef>): number {
  const [scale, setScale] = useState(calculateScale(heatmapHeight, canvasRef));
  useLayoutEffect(() => {
    const debouncedUpdateScale = debounce(
      () => setScale(calculateScale(heatmapHeight, canvasRef)),
      500,
      { maxWait: 1000 },
    );
    window.addEventListener('resize', debouncedUpdateScale);
    return () => window.removeEventListener('resize', debouncedUpdateScale);
  }, [heatmapHeight, canvasRef]);
  return scale;
}
